import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TaskDialog from "./TaskDialog";
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import moment from 'moment'
import config from "../../config/config";
import axios from 'axios';

import IconLabelButtons from '../SharedComponents/KRIMonitoring_updateButton'


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    card: {
        textAlign: "center",
        height: '500px'
    }
})

class TaskList extends Component {
    state = {
        view: false,
        queryID: '',
        open: false,
        scroll: 'paper',
        selectedTask: '',
        dialogOpen: false,
        taskDialogOpen: false,
        taskInfoForResponse:{}
    };

    componentDidUpdate(prevProps) {
    }


    handleTaskSumitUpdate = () => {
        console.log('refrash task list');
        this.props.submitUpdate();
    };


    handleFileDownload = (id,name) => {
        axios({
            url: config.attachment + "/" + id,
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', name)
            document.body.appendChild(link)
            link.click()
        }).catch(error => {console.log(error.response)})
    };

    render() {

        const classes = this.props;
        console.log(this.props.kri)
        return (
            <Card className={classes.card} style={{height: '500px'}}>

                <Typography variant='h6' align='center' style={{padding: '30px'}}>
                    Please fill in {this.props.kri.description} for the month of {moment(this.props.kri.period).format('MMM YYYY')}
                </Typography>

                <IconLabelButtons threshold={this.props.threshold} update={this.props.update} kri={this.props.kri}/>
            </Card>
        )
    }
}

TaskList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaskList);


// WEBPACK FOOTER //
// ./src/components/KRI/KRIReportingTask.js